module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoExBdOl.c169accc.otf";